import React from "react";
import CTA from "./CTA";
import ME from "../../assets/home.svg";
import "./home.css";
import HomeSocial from "./HomeSocial";
const Header = () => {
  return (
    <div className="home">
      <div className="home__container container grid">
        <div className="home__data">
          <h1>
            <span>Hello I'm</span> <br /> Rabih Noureddine
          </h1>
          <h5>ECE & Telecom Engineer</h5>
          <p className="home__description">
            I am a telecom engineer passionate about seamless connections 
            and innovation, fueled by a constant thirst for learning.
          </p>
          <CTA />
          <HomeSocial />
        </div>
        <img src={ME} alt="Home imageU" className="home__img" />
      </div>
    </div>
  );
};

export default Header;
